import VSnackBarQueue from 'vuetify-snackbar-queue/src/components/VSnackbarQueue.vue'

export default {
    install(Vue: any) {
        Vue.component('v-snackbar-queue', VSnackBarQueue)
    }
}
